/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAssetCustomFieldValueRequestDto
 */
export interface UpdateAssetCustomFieldValueRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetCustomFieldValueRequestDto
     */
    value?: string | null;
}

/**
 * Check if a given object implements the UpdateAssetCustomFieldValueRequestDto interface.
 */
export function instanceOfUpdateAssetCustomFieldValueRequestDto(value: object): value is UpdateAssetCustomFieldValueRequestDto {
    return true;
}

export function UpdateAssetCustomFieldValueRequestDtoFromJSON(json: any): UpdateAssetCustomFieldValueRequestDto {
    return UpdateAssetCustomFieldValueRequestDtoFromJSONTyped(json, false);
}

export function UpdateAssetCustomFieldValueRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAssetCustomFieldValueRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function UpdateAssetCustomFieldValueRequestDtoToJSON(json: any): UpdateAssetCustomFieldValueRequestDto {
    return UpdateAssetCustomFieldValueRequestDtoToJSONTyped(json, false);
}

export function UpdateAssetCustomFieldValueRequestDtoToJSONTyped(value?: UpdateAssetCustomFieldValueRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

